/**
@license
Copyright (c) 2016 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
import * as utils from '../utils.js';
// prettier-ignore
import {addEventListener, removeEventListener, dispatchEvent} from '../patch-events.js';

export const WindowPatches = utils.getOwnPropertyDescriptors({
  // Ensure that `dispatchEvent` is patched directly on Window since on
  // IE11, Window does not descend from EventTarget.
  dispatchEvent,

  // NOTE: ensure these methods are bound to `window` so that `this` is correct
  // when called directly from global context without a receiver; e.g.
  // `addEventListener(...)`.
  addEventListener: addEventListener.bind(window),

  removeEventListener: removeEventListener.bind(window),
});
